import { AlertTriangle } from "lucide-react";

export default function DeleteProgrammeModal({
  isOpen,
  programmeName,
  onCancel,
  onConfirm
}) {

  if (!isOpen) return null;

  return (

    <div className="admin-modal-overlay">

      <div className="admin-modal admin-delete-modal">

        <div className="admin-modal-header">

          <h2>Delete Programme</h2>

        </div>

        <div className="admin-modal-body">

          <div className="admin-delete-icon">

            <AlertTriangle size={34} strokeWidth={2.2} />

          </div>

          <p className="admin-delete-message">

                Are you sure you want to permanently delete this programme?

          </p>

          <h3 className="admin-delete-programme">

            {programmeName}

          </h3>

          <p className="admin-delete-warning">

            This action cannot be undone.

          </p>

          <div className="admin-modal-footer">

            <button
              className="admin-secondary-btn"
              onClick={onCancel}
            >
              Cancel
            </button>

            <button
              className="admin-danger-btn"
              onClick={onConfirm}
            >
              Delete
            </button>

          </div>

        </div>

      </div>

    </div>

  );

}